const azureConfig = {
    clientId: '450a0ff7-cbcd-42ee-ac99-ceb885f5a592',
    tenantId: '9f8ae321-aa8f-4c38-90e3-bad7990d7d3e',
    redirectUri: process.env.REACT_APP_BOT_BASE_URL,
    authorityBase: 'https://login.microsoftonline.com',
    scopes: (process.env.REACT_APP_AZURE_AD_SCOPES || 'openid profile email')
        .split(' ')
        .map((s) => s.trim())
        .filter((s) => s.length > 0),
}

export default azureConfig
